module.exports = __webpack_public_path__ + "4caa210d7c5288e95062442967402b43.svg";